<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-departamento')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-departamento')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" :status-icon="true" :rules="rules"
        :inline-message="true">
        <el-form-item :label="userType === '2' ? $t('filial') : $t('cliente')" prop="branch"
          v-if="userType !== '5' && !id">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <CustomerList v-model="ruleForm.customer" v-bind:current="ruleForm.customer"
              v-bind:customerType="userType === '2' ? 3 : ''" />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input ref="code" :disabled="id !== ''" v-model="ruleForm.code"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('limite-credito')" prop="limit">
          <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4">
            <el-input-number :precision="2" v-model="ruleForm.limit"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item v-if="userType === '1' || userType === '3'" prop="chat">
          <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4">
            <el-checkbox v-model="ruleForm.chat">Habilita Chat</el-checkbox>
          </el-col>
          <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4">
            <el-color-picker v-model="ruleForm.color" :predefine="predefineColors" :disabled="ruleForm.chat == false">
            </el-color-picker>
          </el-col>
        </el-form-item>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { UserService } from "@/services/users/user.services";
import { DepartmentService } from "@/services/department/department.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

export default {
  name: "DepartmentAdd",
  components: {
    CustomerList,
  },
  data() {
    return {
      id: "",
      userType: "2",
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
      ],
      ruleForm: {
        name: "",
        code: "",
        customer: "",
        limit: 0,
        chat: false,
        color: '#fff',
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "department",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      DepartmentService.get(vm.id)
        .then((response) => {
          console.log('response', response);
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
          vm.ruleForm.customer = response.customer ? response.customer.id : null;
          vm.ruleForm.limit = +response.limit;
          vm.ruleForm.chat = response.chat;
          vm.ruleForm.color = response.color;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          DepartmentService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("departamento-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          DepartmentService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("departamento-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.get();
        } else {
          vm.$refs.code.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
